module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/sts-2011-06-15.paginators.json
// module id = ./node_modules/aws-sdk/apis/sts-2011-06-15.paginators.json
// module chunks = vendor